var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('p',{staticClass:"header"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"content",class:{ bold: _vm.bold, clickable: _vm.clickable },on:{"click":_vm.valueClicked}},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }